import React, { useState } from 'react';
import {
  doc, getDoc, getFirestore, collection, addDoc,updateDoc,
  serverTimestamp, query, where, getDocs,setDoc,deleteDoc ,
  orderBy, limit
} from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import {
  getStorage, ref, uploadString,  uploadBytesResumable,
  getDownloadURL
} from 'firebase/storage';
import BackHomeButton from '../components/BackHomeButton';
import RazorpayButton from '../components/RazorpayButton';
import Help_Video from '../components/Help_Video';
import Get_Help from '../components/Get_Help';
import { db, auth } from '../firebase';

import { useEffect,useRef  } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import { jsPDF } from "jspdf";
import html2pdf from 'html2pdf.js';
import logo from '../New_Logo.png'; // Replace with actual logo path

import { functions } from '../firebase'; // Ensure path is correct
import { httpsCallable } from 'firebase/functions';

//import * as pdfjs from "pdfjs-dist";
//const { getDocument, GlobalWorkerOptions } = pdfjs;

// Tell pdfjs where to find the worker
//GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js`;

import * as pdfjsLib from "pdfjs-dist/webpack";

function Eascode_Agent_Lesson_CBSE_NCERT() {

  const [subject, setSubject] = useState('');
  const [topic, setTopic] = useState('');
  const [questionType, setQuestionType] = useState('');
  const [extraInfo, setExtraInfo] = useState('');
  const [aiResult, setAiResult] = useState('');
  const [generationsLeft, setGenerationsLeft] = useState('');
  const [message, setMessage] = useState('');
  const [standard, setStandard] = useState('unspecified');
  const [school, setSchool] = useState('unspecified');
  const [showMasterTextDropdown, setShowMasterTextDropdown] = useState(false);
  const [masterTextOptions, setMasterTextOptions] = useState([]);
  const [selectedMasterText, setSelectedMasterText] = useState('');
   const [format, setFormat] = useState('');
   const [lessonName,setlessonName] = useState('');
   const [ Premiumenddate,setPremiumenddate ] = useState('');
   const [aiTopicOptions, setAiTopicOptions] = useState([]);


   const [loading, setLoading] = useState(false);

  const [savedLessons, setSavedLessons] = useState([]);
  //const [selectedLessonId, setSelectedLessonId] = useState('');

  const [selectedLessonText, setSelectedLessonText] = useState('');

  const [selectedLessonIds, setSelectedLessonIds] = useState([]);
  const [selectedTopics, setSelectedTopics] = useState([]);
  const [selectedlessonName, setselectedlessonName] = useState('');
  const [UserType,setUserType]=useState('');
  const [book, setBook] = useState('');

  const [hideDownloaded, setHideDownloaded] = useState(false);


    // Hover state management
    const [hoveredBtn, setHoveredBtn] = useState(null);
    const [hoveredDrawerItem, setHoveredDrawerItem] = useState(null);
    const [hoveredButton, setHoveredButton] = useState(null);

  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const navigate = useNavigate();

    const [description, setDescription] = useState('');
    const [topicName, setTopicName] = useState('');

    const [difficulty, setdifficulty] = useState('Hard');
    const [preference,setPreference] = useState('No');

   const uploadtopicname = useRef('');

  //const auth = getAuth();
  //const db = getFirestore();
  const storage = getStorage();
  const user = auth.currentUser;

  const location = useLocation();

  const [showReview, setShowReview] = useState(false);
  const [showreward, setshowreward] = useState(false);
  const [reviewPromise, setReviewPromise] = useState(null);
  const [review, setReview] = React.useState(null);

  const [aiSummary, setAiSummary] = useState("");
     
  const [isAiSummaryLoading, setIsAiSummaryLoading] = useState(false);
  
  const [resultsString, setResultsString] = useState("");

  const [recentDownloads, setRecentDownloads] = useState([]);
  const [pauseScroll, setPauseScroll] = useState(false);

  // Pull the language that the user selected on the Home page
  const currentLang = localStorage.getItem('appLang') || 'en';


    useEffect(() => {
    const fetchRecentDownloads = async () => {
      if (!school || !standard) return;
  
      //alert(school);
      //alert(standard);
  
      try {
        const q = query(
          collection(db, 'ai_generated_worksheets'),
          where('school', '==', school),
          where('standard', '==', standard)
        );
  
        const snapshot = await getDocs(q);    
        
        //alert(language);      
  
        const items = [];
        snapshot.docs
          .filter(doc => doc.data().subject === subject)// 🔥 language filter here
          .sort((a, b) => b.data().timestamp?.seconds - a.data().timestamp?.seconds)
          .forEach(doc => {
            const question = doc.data().content;
            if (question && !items.some(item => item.question === question)) {
              items.push({
                label: `Worksheet ${items.length + 1}`,
                question
              });
            }
          });
  
        setRecentDownloads(items.slice(0, 10));
  
      } catch (err) {
        console.error('Error fetching recent downloads:', err);
      }
    };
  
    fetchRecentDownloads();
  }, [school, standard, db,subject,selectedlessonName]);

  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes scrollLeft {
        0% { transform: translateX(0); }
        100% { transform: translateX(-50%); }
      }
    `;
    document.head.appendChild(style);
  }, []);

useEffect(() => {
  // Reset AI topics if no lesson selected or hardcoded subject
  const HARD_CODED_SUBJECTS = ["English Language", "Hindi Language"];

  if (!selectedLessonIds || selectedLessonIds.length === 0 || HARD_CODED_SUBJECTS.includes(subject)) {
    setAiTopicOptions([]);
    setSelectedTopics([]); // clear selected topics
    return;
  }

  const fetchTopics = async () => {
    try {
      let allTopics = [];

      for (const lessonId of selectedLessonIds) {
        const ref = doc(db, "saved_lessons_topics", lessonId);
        const snap = await getDoc(ref);

        if (!snap.exists()) continue;

        const rawTopics = snap.data().topics;

        if (typeof rawTopics === "string") {
          const parsed = rawTopics
            .split("*")
            .map(t => t.trim())
            .filter(Boolean);
          allTopics = [...allTopics, ...parsed];
        } else if (Array.isArray(rawTopics)) {
          allTopics = [...allTopics, ...rawTopics];
        }
      }

      // Remove duplicates
      allTopics = Array.from(new Set(allTopics));

      if (allTopics.length === 0) {
        allTopics = ["Full Text of the Lesson"];
      }

      setAiTopicOptions(allTopics);
      setSelectedTopics([]); // reset selected topics whenever lessons change
    } catch (err) {
      console.error("Failed to fetch AI topics:", err);
      setAiTopicOptions(["Full Text of the Lesson"]);
      setSelectedTopics([]);
    }
  };

  fetchTopics();
}, [selectedLessonIds, subject]);


   useEffect(() => {
      const fetchAIResults = async () => {
        const user = auth.currentUser;
  
        if (!user) return;
  
        try {
          const q = query(
            collection(db, "AI_Results"),
            where("uid", "==", user.uid),
            where("subject","==",subject),
            where("lesson","==",selectedlessonName),
            where("topic","==","Full Text of the Lesson"),
            orderBy("timestamp", "desc"),
            limit(2)
          );
  
          const snapshot = await getDocs(q);
  
          if (snapshot.empty) {
            setResultsString("No results found.");
            return;
          }
  
          let finalText = "";
  
          snapshot.forEach(doc => {
            const data = doc.data();
  
            const wrongAnswers = (data.answers || []).filter(
              ans => ans.isCorrect === false
            );
  
            if (wrongAnswers.length === 0) return;
  
            finalText += `Lesson: ${data.lesson}\n`;
            finalText += `Subject: ${data.subject}\n`;
            finalText += `Wrong Questions:\n`;
  
            wrongAnswers.forEach((ans, index) => {
              finalText += `${index + 1}. ${ans.question}\n`;
            });
  
            finalText += `\n`;
          });
  
          setResultsString(finalText.trim());
  
        } catch (error) {
          console.error("Error fetching results:", error);
        }
      };
  
      fetchAIResults();
  
    }, [user,selectedlessonName,topic,subject]);
  
    useEffect(() => {
    if (!resultsString) return;
  
    const runAI = async () => {
  
      setIsAiSummaryLoading(true);
  
      setAiSummary(resultsString || "Unable to generate summary at the moment.");
      setIsAiSummaryLoading(false);
  
      };
  
      runAI();
    }, [resultsString]);


 
    const handleNavigation = (path, state = {}) => {
    navigate(path, { state });
  };


const getToday = () => {
  const d = new Date();
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const year = d.getFullYear();
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  const seconds = String(d.getSeconds()).padStart(2, '0');

  return `${day}${month}${year}_${hours}${minutes}${seconds}`;

};


// Only runs once per component mount
const [internal_file_identifier] = useState(() => {
  return user.uid + '_AI_Worksheet_' + getToday();
});



const get7DayWindow = () => {
  const now = new Date();
  return new Date(now.setDate(now.getDate() - 30));
};

  const [subjectList, setSubjectList] = useState([]);

useEffect(() => {
    const fetchSubjects = async () => {
      try {
        if (!standard || !school) return;

        const q = query(
          collection(db, 'lessons_ncert'), 
          where('standard', '==', Number(standard))
        );
        const snapshot = await getDocs(q);

        // Use a Map to guarantee unique subjects and link them to their book
        const subjectMap = new Map();

        snapshot.docs.forEach(doc => {
          const data = doc.data();
          if (data.subject) {
            // Extract book name (checks common field names, falls back to subject name)
            const bookName = data.book || data.book_name || data.bookName || data.subject;
            if (!subjectMap.has(data.subject)) {
              subjectMap.set(data.subject, bookName);
            }
          }
        });

        // Ensure core subjects are always present in the dropdown
        const coreSubjects = ["English Language", "Hindi Language"];
        coreSubjects.forEach(core => {
          if (!subjectMap.has(core)) {
            subjectMap.set(core, core); // Fallback book name is the subject itself
          }
        });

        // Convert to an array of objects for easy dropdown rendering
        const formattedSubjects = Array.from(subjectMap.entries())
          .map(([subj, bookName]) => ({
            value: subj, // The clean subject name for the backend
            displayLabel: `${subj} : ${bookName}`, // The UI display
            bookName: bookName // Stored to update the {book} state later
          }))
          .sort((a, b) => a.value.localeCompare(b.value));

        setSubjectList(formattedSubjects);

      } catch (error) {
        console.error('Error fetching subjects:', error);
      }
    };

    fetchSubjects();
  }, [standard, school]);

async function askForReview() {
  return new Promise((resolve) => {
    setShowReview(true);
    setReviewPromise(true);
  });
}

async function fetchAIResponse(prompt) {

  const callGemini = httpsCallable(functions, 'callGemini');

  // 2. Try Gemini as fallback
  try {
    const result = await callGemini({
      contents: [{ role: "user", parts: [{ text: prompt }] }],
    });

    // 🛡️ Secure Note: The App Check token was sent automatically!
    // result.data contains the body of the response from your backend
    return result.data.candidates?.[0]?.content?.parts?.[0]?.text;

  } catch (err) {
    console.error('Gemini error:', err.message);
    
    // Check for specific security failures
    if (err.code === 'failed-precondition') {
      alert("Security Check Failed: Please refresh the page.");
    }
  }

  // If both fail
  alert("All AI engines failed. Try again later.");
  return null;
}

  useEffect(() => {
    const state = location.state;
    if (state) {
      if (state.selectedLessonIds) setSelectedLessonIds(state.selectedLessonIds);
      if (state.subject) setSubject(state.subject);
    }
  }, [location.state]);

  useEffect(() => {
    if (selectedLessonIds && savedLessons.length > 0) {
      const selected = savedLessons.find(l => l.id === selectedLessonIds);
      if (selected) {
        setSelectedLessonText(selected.text || '');
      }
    }
  }, [savedLessons, selectedLessonIds]);

useEffect(() => {
  const fetchSavedLessons = async () => {
    if (!user) return;

    const coreSubjects = ['English Language', 'Hindi Language'];

    const snapshot = await getDocs(collection(db, 'lessons_ncert'));
    const lessons = snapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(item =>
        //(item.email === user.email || item.sharedWith === 'parents') &&
        //item.school === school &&
        (
          coreSubjects.includes(item.subject) || 
          item.standard === Number(standard)
        )
      );
      setSavedLessons(lessons);
      }

  fetchSavedLessons();
}, [user,standard,db]);

useEffect(() => {
  if (!user) return;

  const fetchProfileAndGenerations = async () => {
    try {
      // 1️⃣ Fetch profile first
      const profileRef = doc(db, 'profiles', user.uid);
      const profileSnap = await getDoc(profileRef);

      if (!profileSnap.exists()) return;

      const profileData = profileSnap.data();
      const type = profileData.paidUser || false;
      const endDate = profileData.paidUser_End_Date
        ?.toDate?.()
        ?.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
        .replace(/ /g, '-') || 'Not Set';

      setStandard(profileData.standard || 'unspecified');
      setSchool(profileData.school || 'unspecified');
      setUserType(type);
      setPremiumenddate(endDate);

      //alert(`UserType: ${type}`);
      //alert(`Premiumenddate: ${endDate}`);

      // 2️⃣ Now check generation count
      const todays_date = `${String(new Date().getDate()).padStart(2, '0')}-${["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"][new Date().getMonth()]}-${new Date().getFullYear()}`;

      //alert(`todays_date: ${todays_date}`);

      // Paid & active
      if (type === true && new Date(endDate) >= new Date(todays_date)) {
        setGenerationsLeft(999);
        //alert("Logged in as a premium user");
        return;
      }

      // Paid but expired
      if (type === true && new Date(endDate) < new Date(todays_date)) {
        alert("The Premium Eascode Service has ended.");
        await deleteDoc(doc(db, 'weekly_generations', user.uid));
        await updateDoc(doc(db, 'profiles', user.uid), { paidUser: false });
        return;
      }

      //alert(user.uid);

      // Free user limit check
      const uid = user.uid;
      const docRef = doc(db, 'weekly_generations', uid);
      const docSnap = await getDoc(docRef);
      const sevenDaysAgo = get7DayWindow();

     

      if (!docSnap.exists()) {
        await setDoc(docRef, { timestamps: [] });
        setGenerationsLeft(10);
      } else {
        const data = docSnap.data();
        const recentTimestamps = (data.timestamps || []).filter(ts => new Date(ts) >= sevenDaysAgo);
        setGenerationsLeft(10 - recentTimestamps.length);
      }

    } catch (err) {
      console.error("Error fetching profile or generation count:", err);
    }
  };

  fetchProfileAndGenerations();
}, [user, db]);

async function update_downloaded_ai_file (stars,internal_file_identifier) {

  const docRef = await addDoc(collection(db, "ai_generated_worksheets_feedback"), {
  userId: user?.uid || "anonymous",
  subject,
  timestamp: serverTimestamp(),
  Eascode_internal_file_identifier: internal_file_identifier,
  stars:stars,
  difficulty:difficulty
});


}

  const handleGenerate = async () => {

    //alert(subject);
    //alert(selectedlessonName);
    //alert(selectedLessonText);
    //alert(selectedTopics);
    uploadtopicname.current = selectedTopics;
    //alert(uploadtopicname.current);

    //return;

   try {
      
      const profileRef = doc(db, 'profiles', user?.uid);
      const profileSnap = await getDoc(profileRef);
      if (profileSnap.exists()) {
        const profileData = profileSnap.data();
        setStandard(profileData.standard || 'unspecified');
      }
    } catch (err) {
      console.error('Error fetching user profile:', err);
    }

    const lessonsForSubject = savedLessons
          .filter((lesson) => lesson.subject === subject)
          .sort((a, b) => (a.lessonName || '').localeCompare(b.lessonName || ''));

    if (
      !subject ||
      (lessonsForSubject.length > 0 && selectedLessonIds.length === 0) ||
      selectedTopics.length === 0
    ) {
      alert('Please Provide Subject, Lesson and Topic');
      return;
    }

    if (generationsLeft <= 0) {
      alert('Monthly Limit reached. Please try later or pay to unlock unlimited usage.');
      return;
    }

// 👇 Use selectedTopics if available, otherwise fall back to default list
  const topics = selectedTopics && selectedTopics.length > 0 ? selectedTopics : '';

function getQuestionTypes(subject, topic) {
  const questionTypes = {
    "English Literature": [
      "Question and Answers",
      "Complete the Sentences",
      "Who Said to Whom",
      "Answer in One Word",
      "What is the Meaning of the Following Words",
      "Fill in the Blanks",
      "Make Sentences",
      "Match the Following",
      "True or False"
    ],
    "Hindi Literature": [
      "Question and Answers",
      "Complete the Sentences",
      "Who Said to Whom",
      "Answer in One Word",
      "What is the Meaning of the Following Words",
      "Fill in the Blanks",
      "Make Sentences",
      "Match the Following",
      "True or False"
    ],
    "English Language": [
      "Fill in the Blanks",
      //"Answer in One Word",
      //"Match the Following",
      //"Multiple Choice Questions",
      "Paragraph to fill",
      "rewrite the sentence with correct usage",
      "Identify",
      "Do as Directed"
    ],
    "Hindi Language": [
      "Fill in the Blanks",
      //"Answer in One Word",
      //"Match the Following",
      //"Multiple Choice Questions",
      "Paragraph to fill",
      "rewrite the sentence with correct usage",
      "Identify"
    ],
    "EVS": [
      "Question and Answers",
      "Complete the Sentences",
      "Answer in One Word",
      "Fill in the Blanks",
      "Match the Following",
      "True or False",
      "Multiple Choice Questions",
      "Application and skill based questions on lesson"
    ],
    "GK": [
      "Complete the Sentences",
      "Answer in One Word",
      "Fill in the Blanks",
      "Match the Following",
      "True or False",
      "Multiple Choice Questions"
    ],
    "Moral Science": [
      "Question and Answers",
      "Complete the Sentences",
      "Answer in One Word",
      "What is the Meaning of the Following Words",
      "Fill in the Blanks",
      "Make Sentences",
      "Match the Following",
      "True or False",
      "Multiple Choice Questions"
    ],
    "Social Studies": [
      "Complete the Sentences",
      "Answer in One Word",
      "Fill in the Blanks",
      "Match the Following",
      "True or False",
      "Multiple Choice Questions",
      "Application and skill based questions on lesson"
    ],
    "Science": [
      "Complete the Sentences",
      "Answer in One Word",
      "Fill in the Blanks",
      "Match the Following",
      "True or False",
      "Multiple Choice Questions",
      "Application and skill based questions on lesson"
    ],
    "Other": [
      "Complete the Sentences",
      "Answer in One Word",
      "Fill in the Blanks",
      "Match the Following",
      "True or False",
      "Multiple Choice Questions"
    ]
  };

  const mathsQuestionTypesByTopic = {
    "Addition": ["Fill in the Blanks", "Multiple Choice Questions"],
    "Ascending and Descending Order": ["Arrange in Order", "Fill in the Blanks"],
    "Comparison": ["Greater or Smaller", "Multiple Choice Questions"],
    "Division": ["Fill in the Blanks", "Story Sums"],
    "Four Digit Addition and Subtraction": ["Fill in the Blanks", "Story Sums"],
    "Missing Numbers": ["Fill in the Blanks", "Multiple Choice Questions"],
    "Multiplication": ["Fill in the Blanks", "Story Sums"],
    "Number Names": ["Write the Number", "Write the Name"],
    "Repeated Addition": ["Fill in the Blanks"],
    "Repeated Multiplication": ["Fill in the Blanks"],
    "Repeated Subtraction": ["Fill in the Blanks"],
    "StorySums for Addition and Subtraction": ["Fill in the Blanks"],
    "StorySums for Multiplication and Division": ["Fill in the Blanks"],
    "Subtraction": ["Fill in the Blanks", "Multiple Choice Questions"],
    "Two Digit Multiplication": ["Fill in the Blanks", "Story Sums"]
  };

  if (subject === "Mathematics") {
    return mathsQuestionTypesByTopic[topic] || [];
  } else {
    return questionTypes[subject] || questionTypes["Other"];
  }
}

let questionList = "";

try {
  //alert("STEP 1: Starting Firestore query...");

  const q = query(
    collection(db, "ai_generated_worksheets"),
    where("userId", "==", user.uid),
    where("subject", "==", subject),
    where("lesson", "==", selectedlessonName),
    orderBy("timestamp", "desc"),
    limit(1)
  );

  //alert("STEP 2: Query created, fetching docs...");

  const snapshot = await getDocs(q);

  //alert("STEP 3: Response received. Empty? " + snapshot.empty);

  if (snapshot.empty) {
    
  }else
  {
  const docData = snapshot.docs[0].data();
  // extract question field from each object in `answers` array
  questionList = docData.content || "";
  }

} catch (error) {
  alert("❌ ERROR: " + error.message);
  console.error("❌ Error fetching questions:", error);
  return [];
}

  //alert(questionList);


  let prompt = `Create a worksheet for standard ${standard}.\nSubject: ${subject}. \n`;

        if (preference === "No")
        {
        prompt+= `make sure no question is neither same nor similar to the below questions ${questionList}` 
        }

        if (preference === "Yes")
        {
        prompt+= ` only frame questions from below set of questions  ${aiSummary}` 
        }   


  if (selectedLessonText) {
    prompt += `\nYou must strictly use the topics as """${selectedTopics}"""\n
    No need to split questions by topics just make all questions based on question type and mix across topics 
    \n.Here is the lesson text to be used strictly:\n"""${selectedLessonText}"""\n 
    Multiple lessons can be split using ***EOL*** so do not mix lessons for making questions
    Use different parts of any lesson to frame the questions not just one section of it \n`;
  }

  prompt += `Do not highlight or identify the answer in the question text in any shape or form,
    For each of the following topics and question types, 
    create 10 sample questions, different from each other across topics and question type:\n`;

for (let topic of topics) {
  prompt += `\nTopic: ${topic}\n`;
  if (topic === 'Who Said to Whom') {
    prompt += `- Multiple Choice Questions\n`;
  } else {
    for (let type of getQuestionTypes(subject,topic)) {
      prompt += `- ${type}\n`;
    }
  }
}

  if(subject != 'Mathematics')
  {
      if(difficulty === 'Easy')
      {
        prompt +=`Also Please use the following instructions to frame the questions Keep the questions Easy that is small easy to understand sentences for this standard\n`
      }
      if(difficulty === 'Medium')
      {
        prompt +=`Also Please use the following instructions to frame the questions Keep the questions medium difficulty that is medium in length but easy to understand sentences for this standard\n`
      }
      if(difficulty === 'Hard')
      {
        prompt +=`Also Please use the following instructions to frame the questions Keep the questions hard in difficulty that is analytical indepth questions with longer answers\n`
      }
  }

  if(subject === 'Mathematics')
  {
      if(difficulty === 'Easy')
      {
        prompt +=`Also Please use the following instructions to frame the questions Keep the questions Easy for this standard use 2 digit numbers in the questions\n`
      }
      if(difficulty === 'Medium')
      {
        prompt +=`Also Please use the following instructions to frame the questions Keep the questions medium difficulty that is use slightly bigger numbers 2-3 digits in the questions\n`
      }
      if(difficulty === 'Hard')
      {
        prompt +=`Also Please use the following instructions to frame the questions Keep the questions hard in difficulty that is use big numbers 3-4 digits in the questions,complex scenarios\n`
      }
  }

  if(extraInfo.length > 0)
  {
    prompt +=`Please use the following instructions to frame the questions :  ${extraInfo}`
  }

  prompt += `\nGroup all the questions first. After all questions, give the answers section.\n
  Please avoid any suggestions or comments in the output.\n`;

  prompt += `\nCRITICAL INSTRUCTION: You MUST generate the final worksheet entirely in the language corresponding to this ISO code: ${currentLang}.\n`;

    //alert(prompt);

    setMessage(`Generating Worksheet from AI...`);

    setLoading(true);

    try {
      
      const content = await fetchAIResponse(prompt);

      if (!content) {
        alert('Failed to generate response from AI.');
        setMessage('AI did not return a response.');
        return;
      }

      setAiResult(content);

      const docRef = await addDoc(collection(db, 'ai_generated_worksheets'), {
        userId: user?.uid || 'anonymous',
        subject,
        topics,
        questionType,
        extraInfo,
        content,
        timestamp: serverTimestamp(),
        Eascode_internal_file_identifier:internal_file_identifier,
        difficulty:difficulty,
        standard: standard || 'Missing Standard',
        school: school || 'Missing School',
        lesson:selectedlessonName || 'Missing Lesson',
        lessonid:selectedLessonIds || 'Missing Lesson IDs',
      });

      //alert(0);

      const storageRef = ref(storage, `ai_worksheets/${user?.uid}/${docRef.id}.txt`);
      //alert(storageRef);
      await uploadString(storageRef, content);

      if (UserType === false) {

    const rewardref = await addDoc(collection(db, 'Reward_Capture'), {
      uid: user.uid,
      user_email:user.email,
      timestamp: new Date(),
      reward_category:'AI_Worksheet',
    });

  }

      //alert(1);
      const uid = user.uid;
      const doc_Generation = doc(db, 'weekly_generations', uid);
      const docSnap = await getDoc(doc_Generation);
      const now = new Date().toISOString();
      const oldTimestamps = (docSnap.data()?.timestamps || []).filter(ts => {
      return new Date(ts) >= get7DayWindow();
      });

      //alert(2);

      const updatedTimestamps = [...oldTimestamps, now];
      await setDoc(doc_Generation, { timestamps: updatedTimestamps });

      const todays_date = `${String(new Date().getDate()).padStart(2, '0')}-${["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"][new Date().getMonth()]}-${new Date().getFullYear()}`;
 
      if (UserType === true && new Date(Premiumenddate) >= new Date(todays_date)) {
      setGenerationsLeft(999);
      //alert('x');
    //alert(`user type`+UserType);
    //alert(`Premiumenddate`+Premiumenddate);
    //alert(`todays_date`+todays_date);
      }
      else{
       setGenerationsLeft(10 - updatedTimestamps.length); 
             //alert('y');
    //alert(`user type`+UserType);
    //alert(`Premiumenddate`+Premiumenddate);
    //alert(`todays_date`+todays_date);
      }

      setMessage('Generation successful!');

      //alert(3);

    } catch (err) {
      console.error(err);
      alert('Something went wrong: ' + err.message);
      setMessage('Failed to generate. Please try again.');
    }
    finally {
      //alert(4);
    setLoading(false); // 🔓 Re-enable UI
    setSelectedLessonIds([]); 
    setSelectedLessonText(''); 
    setTopic('');
    setQuestionType('');
    setExtraInfo('');
    setSelectedTopics([]);

    //alert(subject);
    //alert(selectedLessonIds);
    //alert(selectedTopics);



  }
  };

    const generatePdfBlob = async () => {
    return new Promise((resolve, reject) => {

      const wrapper = document.createElement('div');
      wrapper.style.position = 'relative';
      wrapper.style.fontFamily = 'Arial, sans-serif';
      wrapper.style.whiteSpace = 'pre-wrap';
      wrapper.style.padding = '40px 40px 40px 40px'; // top, right, bottom, left;
      wrapper.style.width = '90%';

      // Add image
      const placeholderImage = document.createElement('img');
      placeholderImage.src = logo; // <-- replace with actual URL or base64
      placeholderImage.style.display = 'block';
      placeholderImage.style.margin = '0 auto'; // center
      placeholderImage.style.width = '150px';   // adjust size
      placeholderImage.style.height = 'auto';
      wrapper.appendChild(placeholderImage);

      // Add placeholder (first half of first page)
      const placeholder = document.createElement('div');
      placeholder.innerText = 'Eascode';
      placeholder.style.fontSize = '48px';
      placeholder.style.fontWeight = 'bold';
      placeholder.style.textAlign = 'center';
      placeholder.style.marginTop = '10px';
      placeholder.style.marginBottom = '10px';
      wrapper.appendChild(placeholder);

      const placeholder_value = document.createElement('div');
      placeholder_value.innerText = 'For Parents by Parents';
      placeholder_value.style.fontSize = '24px';
      placeholder_value.style.fontWeight = 'bold';
      placeholder_value.style.textAlign = 'center';
      placeholder_value.style.marginTop = '10px';
      placeholder_value.style.marginBottom = '10px';
      wrapper.appendChild(placeholder_value);

    // Add label before URL
    const toolUrlLabel = document.createElement('div');
    toolUrlLabel.innerText = 'For more worksheets based on your school syllabus and pattern visit : :'; 
    toolUrlLabel.style.fontSize = '16px';
    toolUrlLabel.style.fontWeight = 'bold';
    toolUrlLabel.style.textAlign = 'center';
    toolUrlLabel.style.marginBottom = '5px';
    wrapper.appendChild(toolUrlLabel);

    // Add tool URL (clickable)
    const toolUrl = document.createElement('a');
    toolUrl.href = 'https://eascode.web.app/login'; // <-- replace with your tool URL
    toolUrl.innerText = 'https://eascode.web.app/login';
    toolUrl.style.fontSize = '16px';
    toolUrl.style.color = 'blue';
    toolUrl.style.textAlign = 'center';
    toolUrl.style.display = 'block';
    toolUrl.style.marginBottom = '50px';
    toolUrl.style.textDecoration = 'underline';
    wrapper.appendChild(toolUrl);

      // Actual AI result after placeholder
      const content = document.createElement('div');
      content.innerText = aiResult;
      wrapper.appendChild(content);

      //wrapper.innerText = aiResult;
  
      const watermark = document.createElement('div');
      watermark.innerText = 'Eascode';
      watermark.style.position = 'fixed';
      watermark.style.top = '50%';
      watermark.style.left = '50%';
      watermark.style.transform = 'translate(-50%, -50%) rotate(-30deg)';
      watermark.style.fontSize = '120px';
      watermark.style.color = 'rgba(0, 0, 0, 0.05)';
      watermark.style.zIndex = '0';
      watermark.style.pointerEvents = 'none';
      watermark.style.userSelect = 'none';
      watermark.style.width = '100%';
      watermark.style.textAlign = 'center';
      wrapper.appendChild(watermark);

      // Add legal terms (last page footer)
    const legalTerms = document.createElement('div');
    legalTerms.innerText = 
      'Terms & Conditions:\n\n' +
  'This document is provided for personal use only. Unauthorized copying, ' +
  'reproduction, distribution, or modification of any part of this content is strictly prohibited. ' +
  'No portion of this material may be stored in a retrieval system, transmitted, or otherwise ' +
  'used in any form or by any means—electronic, mechanical, photocopying, recording, or otherwise— ' +
  'without the prior written permission of Eascode. All intellectual property rights, including ' +
  'but not limited to copyrights, trademarks, and design rights, are fully reserved.\n\n' +
  '© Eascode Pvt. Ltd.' + new Date().getFullYear()+ 
  '. \n All rights reserved. Unauthorized use of this document or its contents may result in ' +
  'civil and/or criminal liability under applicable laws.\n\n' +
  'By using, viewing, or distributing this document, you expressly agree to comply with these terms.';

    legalTerms.style.fontSize = '12px';
    legalTerms.style.color = '#444';
    legalTerms.style.textAlign = 'justify';
    legalTerms.style.marginTop = '100px';
    legalTerms.style.padding = '20px 40px';
    wrapper.appendChild(legalTerms);
  
      document.body.appendChild(wrapper);
  
      const opt = {
        margin: 0.5,
        filename: 'temp.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
      };
  
      html2pdf().set(opt).from(wrapper).outputPdf('blob').then((blob) => {
        document.body.removeChild(wrapper);
        resolve(blob);
      }).catch((err) => {
        document.body.removeChild(wrapper);
        reject(err);
      });
    });
  };


  const handleDownload = async () => {

  //const review = await askForReview();

  askForReview();

  const blob = await generatePdfBlob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `Eascode_AI_${subject}_Multiple_Lesson_Multiple_Topics_worksheet.pdf`;
  a.click();
  URL.revokeObjectURL(url);
};

const handleUpload = async () => {

  //alert(uploadtopicname.current);
  //return;

if (!subject || !selectedTopics ) {
      alert('Please fill all required fields.');
      return;
  }

  const selectedLesson = savedLessons.find(lesson => lesson.id === selectedLessonIds);
  const finalLessonName = selectedLesson?.lessonName || '';

  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) {
    alert('User not logged in');
    return;
  }

  const profilesRef = collection(db, 'profiles');
  const querySnapshot = await getDocs(query(profilesRef, where('uid', '==', user.uid)));

  if (querySnapshot.empty) {
    alert('Profile not found for this user.');
    return;
  }

  const profileData = querySnapshot.docs[0].data();
  const dt = getToday();
  const fileName = `Eascode_AI_Std_${profileData.standard}_${subject}_Multiple_Lesson_Multiple_Topics_worksheet_${dt}`;
  const storageRef = ref(storage, `uploads/${fileName}.pdf`);

  const fileBlob = await generatePdfBlob();  // <--- use PDF Blob here

  setUploading(true);

  const uploadTask = uploadBytesResumable(storageRef, fileBlob);

  uploadTask.on(
    'state_changed',
    (snapshot) => {
      const prog = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
      setProgress(prog);
    },
    (error) => {
      console.error(error);
      setUploading(false);
      alert('Error uploading file');
    },
    async () => {
      const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);

      await addDoc(collection(db, 'uploads'), {
          fileName,
          fileUrl: downloadURL,
          description : 'AI generated Worksheet',
          subject,
          topicName : uploadtopicname,
          calculatedFileName: fileName,
          uploadedBy: user.email,
          uid: user.uid,
          uploadTime: serverTimestamp(),
          standard: profileData.standard || '',
          school: profileData.school || '',
          city: profileData.city || '',
          type : 'AI_Worksheet',
          selectedLessonIds,
          lessonName: selectedlessonName,          
          uploadername:profileData.name || 'User not found'
      });

      alert('AI-generated file uploaded successfully!');
      setUploading(false);
      setDescription('');
      setSubject('');
      setTopicName('');
      setProgress(0);
      setAiResult('');
      //navigate('/home');
    }
  );
};


   return (
    <>
      {/* 🔹 Inject CSS here */}
      <style>{`
        /* Hide Google Translate UI */
        #google_translate_element { display: none !important; }
        .goog-te-banner-frame { display: none !important; }
        .skiptranslate { display: none !important; }
        body { top: 0px !important; }

        @keyframes fadeIn {
          from { opacity: 0; }
          to   { opacity: 1; }
        }
        @keyframes pop {
          0%   { transform: scale(0.9); opacity: 0; }
          100% { transform: scale(1); opacity: 1; }
        }
      `}</style>

      <div className="min-h-screen bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-indigo-50 via-slate-50 to-white py-2 sm:py-6 px-2 sm:px-6 lg:px-8 font-sans">
        
        {/* W-FULL instead of max-w constraints to use the full screen width */}
        <div className="w-full mx-auto bg-white/80 backdrop-blur-xl rounded-[1rem] sm:rounded-[2rem] shadow-2xl shadow-indigo-500/10 border border-white p-3 sm:p-8 relative overflow-hidden">
          
          {/* Top Nav & Header - All Inline */}
          <div className="flex items-center justify-between mb-2 sm:mb-4 w-full gap-2">
            <div className="flex-1 flex justify-start min-w-0">
              <BackHomeButton
                backState={{ selectedLessonIds, subject }}
                disabled={loading}
              />
            </div>

            <div className="flex-auto text-center px-1 sm:px-4 shrink-0">
              <h2 className="text-sm sm:text-2xl md:text-3xl font-extrabold text-slate-900 tracking-tight leading-tight whitespace-nowrap">
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-violet-600">Worksheet Generator</span>
              </h2>
            </div>

            <div className="flex-1 flex justify-end min-w-0">            
              <Get_Help/>
            </div>



 {/*           
            <div className="flex-1 flex justify-end min-w-0">
              <div className="relative group overflow-hidden bg-gradient-to-r from-indigo-600 via-violet-600 to-purple-700 p-[1px] rounded-full transition-transform hover:scale-[1.02] shrink-0">
                <div className="bg-slate-900/10 backdrop-blur-md px-2 py-1 sm:px-4 sm:py-2 rounded-full flex items-center gap-1 sm:gap-2 text-white shadow-inner">
                  <span className="text-[10px] sm:text-base animate-bounce">🎁</span>
                  <p className="text-[8px] sm:text-xs font-medium leading-tight whitespace-nowrap">
                    <span className="hidden lg:inline">Download </span>
                    <span className="text-yellow-400 font-bold">
                      10 <span className="hidden sm:inline">Worksheets</span><span className="sm:hidden">WS</span>
                    </span> 
                  </p>
                </div>
              </div>
            </div>
*/}

          </div>


                     {/* Drop your reusable component here */}
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'start' }}>
                  <Help_Video 
                    videoId="ytTHnwdIl4A" /* ⚠️ Replace with actual YouTube ID */
                    title="How to use Voice to Text" 
                  />
                </div>

                <br></br>

{/*          <div className="text-center mb-4 sm:mb-8">
            <p className="text-[10px] sm:text-sm text-slate-500 font-medium w-full mx-auto px-2">
              This Tool will make 1 Worksheet for the selected Subject, Lessons, and Topics in the language chosen.
            </p>
          </div>
*/}
          {/* Trending Downloads */}
          {recentDownloads.length > 0 && (
            <div className="mb-4 sm:mb-8 bg-slate-50 border border-slate-200 rounded-lg sm:rounded-xl p-2 sm:p-4 shadow-sm">
              <div className="flex items-center gap-2 mb-2 sm:mb-3 text-[9px] sm:text-xs font-bold text-slate-500 uppercase tracking-widest">
                <span className="flex h-1.5 w-1.5 sm:h-2 sm:w-2 rounded-full bg-orange-500 animate-pulse"></span>
                Recently downloaded in your school
              </div>
              <div 
                className="overflow-hidden w-full mask-linear-gradient"
                onMouseEnter={() => setPauseScroll(true)}
                onMouseLeave={() => setPauseScroll(false)}
              >
                <div 
                  className="flex gap-2 w-max"
                  style={{
                    animation: recentDownloads.length > 1 ? 'scrollLeft 25s linear infinite' : 'none',
                    animationPlayState: pauseScroll ? 'paused' : 'running',
                  }}
                >
                  {(recentDownloads.length > 1 ? [...recentDownloads, ...recentDownloads] : recentDownloads).map((item, index) => (
                    <span
                      key={index}
                      className="bg-white border border-slate-200 hover:border-indigo-400 hover:text-indigo-600 transition-colors px-2 py-1 sm:px-4 sm:py-2 rounded-full text-[10px] sm:text-sm font-semibold text-slate-600 shadow-sm cursor-pointer whitespace-nowrap"
                      onClick={() => setAiResult(item.question)}
                      title={item.question}
                    >
                      🔥 {item.label}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Form Grid: Subject & Difficulty */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-6 mb-4 sm:mb-6">
            <div className="space-y-1">
              <label className="block text-[11px] sm:text-sm font-bold text-slate-700 ml-1">Choose Subject</label>
              <select
                value={subject}
                disabled={loading}
                onChange={(e) => {
                  const selectedVal = e.target.value;
                  setSubject(selectedVal);
                  
                  // Find the matching object to update the book state for the Lessons label
                  const selectedObj = subjectList.find(s => s.value === selectedVal);
                  if (selectedObj) {
                    setBook(selectedObj.bookName);
                  } else {
                    setBook('');
                  }
                  
                  setSelectedTopics([]);
                  setSelectedLessonIds([]);
                }}
                className="w-full bg-slate-50 border-2 border-slate-200 rounded-md sm:rounded-xl px-2 py-1.5 sm:px-3 sm:py-3 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/10 transition-all outline-none text-[11px] sm:text-base font-semibold text-slate-700 cursor-pointer appearance-none"
              >
                <option value="">Select Subject</option>
                {subjectList.map((item, idx) => (
                  <option key={idx} value={item.value}>
                    {item.displayLabel}
                  </option>
                ))}
              </select>
            </div>

            {subject && (
              <div className="space-y-1 animate-in fade-in zoom-in-95 duration-200">
                <label className="block text-[11px] sm:text-sm font-bold text-slate-700 ml-1 flex flex-wrap items-baseline gap-1">
                  Difficulty Level
                  <span className="text-[9px] sm:text-[10px] text-rose-500 font-medium">(varies question types*)</span>
                </label>
                <select
                  value={difficulty}
                  onChange={(e) => setdifficulty(e.target.value)}
                  required
                  className={`w-full border-2 rounded-md sm:rounded-xl px-2 py-1.5 sm:px-3 sm:py-3 text-[11px] sm:text-base font-bold transition-all outline-none cursor-pointer appearance-none
                    ${difficulty === 'Easy' ? 'bg-emerald-50 border-emerald-200 text-emerald-800' : 
                      difficulty === 'Medium' ? 'bg-amber-50 border-amber-200 text-amber-800' : 
                      'bg-rose-50 border-rose-200 text-rose-800'}`}
                >
                  <option value="Easy">🟢 Easy</option>
                  <option value="Medium">🟡 Medium</option>
                  <option value="Hard">🔴 Hard</option>
                </select>
              </div>
            )}
          </div>

          {/* Lists Grid: Lessons & Topics */}
          {subject && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-6 mb-4 sm:mb-6 bg-slate-50 border border-slate-200 p-2 sm:p-5 rounded-lg sm:rounded-2xl shadow-sm">
              
              <div className="flex flex-col h-full">
                <label className="block text-[11px] sm:text-sm font-bold text-indigo-900 mb-1.5 sm:mb-3 uppercase tracking-wider border-b border-slate-200 pb-1">
                  Lessons under {subject} , Book : {book}
                </label>
                <div className="flex-1 overflow-y-auto max-h-32 sm:max-h-56 space-y-1 pr-1 custom-scrollbar">
                  {(() => {
                    const lessonsForSubject = savedLessons.filter((lesson) => lesson.subject === subject).sort((a, b) => (a.lessonName || '').localeCompare(b.lessonName || ''));
                    const allSelected = lessonsForSubject.length > 0 && lessonsForSubject.every(lesson => selectedLessonIds.includes(lesson.id));

                    return (
                      <>
                        {lessonsForSubject.length > 0 && (
                          <label className="flex items-center p-1.5 sm:p-3 bg-white rounded-md sm:rounded-xl border border-slate-200 cursor-pointer hover:bg-indigo-50 transition-all">
                            <input
                              type="checkbox"
                              className="w-3 h-3 sm:w-4 sm:h-4 text-indigo-600 rounded border-slate-300"
                              checked={allSelected}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  const allIds = lessonsForSubject.map(lesson => lesson.id);
                                  setSelectedLessonIds(allIds);
                                  setSelectedLessonText(lessonsForSubject.map(l => l.text || l.extracted_text).join('\n\n***EOL***'));
                                  setselectedlessonName(lessonsForSubject.map(l => l.lessonName || l.lesson_name || 'Unnamed_Lesson').join(', '));
                                } else {
                                  setSelectedLessonIds([]);
                                  setSelectedLessonText('');
                                  setselectedlessonName('');
                                }
                              }}
                            />
                            <span className="ml-2 sm:ml-3 text-[11px] sm:text-sm font-bold text-slate-700">Select All</span>
                          </label>
                        )}

                        {lessonsForSubject.map((lesson) => (
                          <label key={lesson.id} className="flex items-center p-1.5 sm:p-3 bg-white rounded-md sm:rounded-xl border border-slate-100 cursor-pointer hover:border-indigo-300 transition-all">
                            <input
                              type="checkbox"
                              value={lesson.id}
                              checked={selectedLessonIds.includes(lesson.id)}
                              className="w-3 h-3 sm:w-4 sm:h-4 text-indigo-600 rounded border-slate-300"
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                const value = e.target.value;
                                let updated = isChecked ? [...selectedLessonIds, value] : selectedLessonIds.filter(id => id !== value);
                                setSelectedLessonIds(updated);
                                const selectedLessons = savedLessons.filter(l => updated.includes(l.id));
                                setSelectedLessonText(selectedLessons.map(l => l.text || l.extracted_text).join('\n\n'));
                                setselectedlessonName(selectedLessons.map(l => l.lessonName || l.lesson_name || 'Unnamed_Lesson').join(', '));
                              }}
                            />
                            <span className="ml-2 sm:ml-3 text-[10px] sm:text-sm font-medium text-slate-600 truncate">{lesson.lessonName || lesson.lesson_name || 'No Title'}</span>
                          </label>
                        ))}

                        {lessonsForSubject.length === 0 && (
                          <div className="p-2 text-center border-2 border-dashed border-slate-200 rounded-md">
                            <p className="text-[10px] text-slate-500 italic">No lessons found. Topics will be used.</p>
                          </div>
                        )}
                      </>
                    );
                  })()}
                </div>
              </div>

              <div className="flex flex-col h-full mt-2 md:mt-0">
                <label className="block text-[11px] sm:text-sm font-bold text-indigo-900 mb-1.5 sm:mb-3 uppercase tracking-wider border-b border-slate-200 pb-1">
                  Please Choose Topics
                </label>
                <div className="flex-1 overflow-y-auto max-h-32 sm:max-h-56 space-y-1 pr-1 custom-scrollbar">
                  {(() => {
                    let topicOptions = [];
                    if (subject === 'English Language') {
                      if (Number(standard) === 2) { topicOptions = ["Adjectives", "Antonyms", "Articles a an the", "Conjunctions and but", "Identify Nouns", "Identify Verbs","Pronouns", "Singular and Plural","Tenses","Adverbs","Verbs","Helping Verbs", "Countable and Uncountable Nouns","Prepositions","Synonyms"]; } 
                      else if (Number(standard) === 3) { topicOptions = ["Adjectives", "Antonyms", "Articles a an the", "Conjunctions and but", "Identify Nouns", "Identify Verbs", "Jumbled Sentences","Tenses","Adverbs", "Pronouns", "Singular and Plural","Gender","Subject and Predicate","Verbs","Countable and Uncountable Nouns", "Prepositions","Synonyms"]; } 
                      else if (Number(standard) === 4) { topicOptions = ["Adjectives", "Antonyms", "Articles a an the", "Conjunctions and but", "Identify Nouns", "Identify Verbs", "Jumbled Sentences","Tenses","Adverbs", "Pronouns", "Singular and Plural","Gender","Subject and Predicate","Verbs","Adverbs","Interjections","Conjunctions", "Countable and Uncountable Nouns","Prepositions","Synonyms"]; } 
                      else if (Number(standard) === 5) { topicOptions = ["Adjectives", "Adjectives Degrees of Comparison", "Antonyms", "Articles a an the", "Conjunctions and but", "Identify Nouns", "Identify Verbs", "Jumbled Sentences","Pronouns", "Singular and Plural","Gender", "Subject and Predicate","Verbs","Adverbs","Kinds of Sentences","Interjections","Conjunctions", "Countable and Uncountable Nouns","Prepositions","Synonyms"]; } 
                      else if (Number(standard) === 6) { topicOptions = ["Adjectives", "Adjectives Degrees of Comparison", "Antonyms", "Articles a an the", "Conjunctions and but", "Identify Nouns", "Identify Verbs", "Jumbled Sentences", "Pronouns", "Singular and Plural","Gender","Subject and Predicate","Verbs","Adverbs","Kinds of Sentences","Interjections","Conjunctions", "Countable and Uncountable Nouns","Prepositions","Synonyms"]; } 
                      else if (Number(standard) === 7) { topicOptions = ["Adjectives", "Adjectives Degrees of Comparison", "Antonyms", "Articles a an the", "Conjunctions and but", "Identify Nouns", "Identify Verbs", "Jumbled Sentences", "Pronouns", "Singular and Plural","Gender","Subject and Predicate","Verbs","Adverbs","Kinds of Sentences", "Prepositions","Past Tense","Present Tense","Future Tense","Interjections","Conjunctions" ,"Countable and Uncountable Nouns","Prepositions","Synonyms"]; } 
                      else if (Number(standard) === 8) { topicOptions = ["Adjectives", "Adjectives Degrees of Comparison", "Antonyms", "Articles a an the", "Conjunctions and but", "Identify Nouns", "Identify Verbs", "Jumbled Sentences", "Pronouns", "Singular and Plural","Gender","Subject and Predicate","Verbs","Adverbs", "Kinds of Sentences","Prepositions","Past Tense","Present Tense","Future Tense","Interjections","Conjunctions", "Countable and Uncountable Nouns","Prepositions","Synonyms"]; } 
                      else { topicOptions = ["Please Specify in Instructions below"]; }
                    } else if (subject === 'Hindi Language') {
                      topicOptions = ["Anunasik", "Anuswar", "Counting 1 to 15", "Paryayvachi", "Saal ke Maheenon ke Naam", "Sangya", "Sarvnaam", "Saptah ke Dinon ke naam", "VakyaRachna", "VilomShabd", "Viram Sign","Visheshan","Kriya","Kaal","Correction of Sentences"];
                    } else {
                      topicOptions = aiTopicOptions.length > 0 ? aiTopicOptions : ['Full Text of the Lesson'];
                    }

                    const allSelected = topicOptions.length > 0 && topicOptions.every(topic => selectedTopics.includes(topic));

                    return (
                      <>
                        {topicOptions.length > 0 && (
                          <label className="flex items-center p-1.5 sm:p-3 bg-white rounded-md sm:rounded-xl border border-slate-200 cursor-pointer hover:bg-indigo-50 transition-all">
                            <input
                              type="checkbox"
                              className="w-3 h-3 sm:w-4 sm:h-4 text-indigo-600 rounded border-slate-300"
                              checked={allSelected}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedTopics(topicOptions);
                                } else {
                                  setSelectedTopics([]);
                                }
                              }}
                            />
                            <span className="ml-2 sm:ml-3 text-[11px] sm:text-sm font-bold text-slate-700">Select All</span>
                          </label>
                        )}

                        {topicOptions.map((t) => (
                          <label 
                            key={t} 
                            className={`flex items-center p-1.5 sm:p-3 bg-white rounded-md sm:rounded-xl border cursor-pointer transition-all shadow-sm
                              ${t === 'Full Text of the Lesson' ? 'border-emerald-300 bg-emerald-50' : 'border-slate-100'}`}
                          >
                            <input
                              type="checkbox"
                              value={t}
                              checked={selectedTopics.includes(t)}
                              className="w-3 h-3 sm:w-4 sm:h-4 text-indigo-600 rounded border-slate-300"
                              onChange={(e) => {
                                const checked = e.target.checked;
                                const value = e.target.value;
                                if (checked) {
                                  setSelectedTopics([...selectedTopics, value]);
                                } else {
                                  setSelectedTopics(selectedTopics.filter(topic => topic !== value));
                                }
                              }}
                            />
                            <span className={`ml-2 sm:ml-3 text-[10px] sm:text-sm ${t === 'Full Text of the Lesson' ? 'font-bold text-emerald-800' : 'font-medium text-slate-600'} truncate`}>
                              {t}
                            </span>
                          </label>
                        ))}
                      </>
                    );
                  })()}
                </div>
              </div>

            </div>
          )}

          {/* Smart AI Section & Account Limits Combined */}
          {subject && (
            <div className="mb-4 sm:mb-6 bg-slate-400 text-white rounded-lg sm:rounded-2xl p-3 sm:p-4 shadow-lg relative overflow-hidden">
              <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-3 relative z-10">
                
                {/* Left: Title */}
                <div className="flex items-center gap-2 shrink-0">
                  <span className="text-lg sm:text-2xl">🧠</span>
                  <div>
                    <h4 className="text-[11px] sm:text-base font-bold leading-none">Adaptive Focus</h4>
                    <p className="text-[9px] sm:text-xs text-indigo-200 mt-0.5">Based on last 2 quizzes.</p>
                  </div>
                </div>
                
                {/* Right: Controls & Limits */}
                <div className="flex flex-wrap items-center gap-2 sm:gap-3">
                  <select
                    value={preference}
                    onChange={(e) => setPreference(e.target.value)}
                    className={`px-2 py-1.5 sm:px-3 sm:py-2 rounded-md sm:rounded-lg text-[10px] sm:text-xs font-bold border-none outline-none text-slate-900 shadow-sm cursor-pointer shrink-0
                      ${preference === "No" ? "bg-slate-200" : "bg-emerald-400"}`}
                  >
                    <option value="No">Disabled</option>
                    <option value="Yes">Enable AI Focus</option>
                  </select>

                  <div className="hidden sm:block w-px h-6 bg-slate-700 mx-1"></div>

                  <div className="bg-slate-800/80 border border-slate-700 px-2 py-1 sm:px-3 sm:py-1.5 rounded-md sm:rounded-lg flex flex-col justify-center min-w-[60px]">
                    <span className="text-[7px] sm:text-[9px] font-bold text-slate-400 uppercase leading-none mb-0.5">Quota</span>
                    <span className="text-[10px] sm:text-xs font-black text-emerald-400 leading-none">{generationsLeft} Left</span>
                  </div>

                  <div className="bg-slate-800/80 border border-slate-700 px-2 py-1 sm:px-3 sm:py-1.5 rounded-md sm:rounded-lg flex flex-col justify-center min-w-[80px]">
                    <span className="text-[7px] sm:text-[9px] font-bold text-slate-400 uppercase leading-none mb-0.5">Premium</span>
                    <span className="text-[10px] sm:text-xs font-black text-white leading-none truncate">{Premiumenddate.toLocaleString().split(',')[0]}</span>
                  </div>
                </div>
              </div>

              {preference === "Yes" && (
                <div className="mt-3 sm:mt-4 bg-slate-800/50 rounded-md sm:rounded-xl p-2 sm:p-4 border border-slate-700 backdrop-blur-sm relative z-10 animate-in slide-in-from-top-2 duration-200">
                  <h5 className="text-[9px] sm:text-xs font-bold text-indigo-300 uppercase tracking-widest mb-1">Identified Weak Sections</h5>
                  {isAiSummaryLoading ? (
                    <div className="flex flex-col items-center justify-center py-2 text-indigo-300">
                      <div className="w-4 h-4 sm:w-6 sm:h-6 border-2 border-indigo-500 border-t-transparent rounded-full animate-spin mb-1"></div>
                      <p className="font-medium animate-pulse text-[9px] sm:text-xs text-center">Analyzing...</p>
                    </div>
                  ) : (
                    <pre className="whitespace-pre-wrap font-mono text-[9px] sm:text-xs leading-tight text-slate-200 overflow-x-auto max-h-16 sm:max-h-32 custom-scrollbar">
                      {aiSummary}
                    </pre>
                  )}
                </div>
              )}
            </div>
          )}

          {/* Action Buttons */}
          <div className="space-y-2 sm:space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-4 w-full">
              {generationsLeft > 0 ? (
                <button
                  onClick={handleGenerate}
                  disabled={loading}
                  onMouseEnter={() => setHoveredButton('worksheet')}
                  onMouseLeave={() => setHoveredButton(null)}
                  className="w-full bg-slate-700 text-white p-2.5 sm:p-4 rounded-lg sm:rounded-2xl font-bold text-[11px] sm:text-base hover:bg-indigo-600 transition-all duration-300 disabled:opacity-50"
                >
                  <span className="flex items-center justify-center gap-1.5 sm:gap-2">
                    {loading ? (
                      <><div className="w-3 h-3 sm:w-5 sm:h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div> Working...</>
                    ) : 'Generate Worksheet'}
                  </span>
                </button>
              ) : (
                <div className="w-full flex justify-center p-2 sm:p-4 bg-rose-50 border border-rose-200 rounded-lg sm:rounded-2xl">
                  <RazorpayButton />
                </div>
              )}

            {generationsLeft > 0 && (
              <button
                onClick={() => setHideDownloaded(prev => !prev)}
                disabled={loading}
                className={`w-full p-2.5 sm:p-4 rounded-lg sm:rounded-2xl font-bold text-[11px] sm:text-base transition-all border-2
                  ${hideDownloaded ? 'bg-rose-50 border-rose-200 text-rose-700' : 'bg-white border-slate-200 text-slate-600 hover:bg-slate-50'}`}
              >
                {loading ? '⏳...' : '🎨 Generate Personal Format Worksheet'}
              </button>
            )}
            </div>
          </div>

          {/* Personal Settings Drawer */}
          {subject && hideDownloaded && (
            <div className="mt-2 sm:mt-6 bg-rose-50 border-2 border-dashed border-rose-200 rounded-lg sm:rounded-3xl p-3 sm:p-6 animate-in zoom-in-95 duration-200">
              <label className="block text-[11px] sm:text-base font-bold text-rose-900 mb-1.5 sm:mb-3">Custom Instructions / Sample Question</label>
              <textarea
                className="w-full bg-white border border-rose-100 rounded-md sm:rounded-xl p-2 sm:p-4 text-[10px] sm:text-sm focus:ring-2 focus:ring-rose-500/20 outline-none resize-y h-16 sm:h-32 custom-scrollbar"
                value={extraInfo}
                onChange={e => e.target.value.length <= 300 && setExtraInfo(e.target.value)}
                placeholder='Specific AI instructions...'
              />
              <div className="flex flex-row justify-between items-center mt-2">
                <span className="text-[9px] sm:text-xs font-bold text-rose-400">{extraInfo.length}/300</span>
                <button 
                  onClick={handleGenerate}
                  disabled={loading}
                  className="bg-rose-600 text-white px-3 py-1.5 sm:px-6 sm:py-3 rounded-md sm:rounded-xl font-bold text-[10px] sm:text-sm hover:bg-rose-700 transition-colors disabled:opacity-50"
                >
                  ✨ Generate Custom
                </button>
              </div>
            </div>
          )}

          {/* Preview & Output Section */}
          <div className="mt-4 sm:mt-10 pt-4 sm:pt-8 border-t border-slate-200 space-y-3 sm:space-5">
            <div className="flex flex-row items-center justify-between">
              <label className="text-[13px] sm:text-lg font-bold text-slate-800">Live Preview</label>
              {uploading && (
                <span className="px-2 py-0.5 sm:px-3 sm:py-1 bg-emerald-100 text-emerald-700 text-[8px] sm:text-[10px] font-bold rounded-full animate-pulse">
                  UPLOADING {progress}%
                </span>
              )}
            </div>
            
            <textarea 
              className="w-full bg-white text-slate-900 font-mono text-[10px] sm:text-sm leading-tight sm:leading-relaxed p-3 sm:p-5 rounded-lg sm:rounded-2xl border-2 border-slate-200 outline-none h-40 sm:h-80 resize-y focus:border-indigo-400 focus:ring-4 focus:ring-indigo-500/10 transition-all custom-scrollbar" 
              value={aiResult} 
              readOnly 
            />

            <div className="grid grid-cols-2 gap-2 sm:gap-4 w-full">
              <button 
                onClick={handleDownload} 
                disabled={!aiResult.trim()} 
                className="w-full bg-white border-2 border-slate-200 text-slate-700 p-2 sm:p-4 rounded-lg sm:rounded-xl font-bold text-[10px] sm:text-base hover:bg-slate-50 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
              >
                📥 Download PDF
              </button>

              <button
                onClick={handleUpload}
                disabled={uploading || !aiResult.trim()} 
                className="w-full bg-emerald-500 text-white p-2 sm:p-4 rounded-lg sm:rounded-xl font-bold text-[10px] sm:text-base hover:bg-emerald-600 transition-all disabled:opacity-50 disabled:cursor-not-allowed relative overflow-hidden"
              >
                {uploading ? (
                  <div className="absolute inset-0 bg-emerald-600 flex items-center justify-center" style={{ width: `${progress}%` }}>
                    <span className="absolute w-full text-center z-10 text-white text-[9px] sm:text-sm">Uploading {progress}%</span>
                  </div>
                ) : '📤 Upload To Eascode'}
              </button>
            </div>
          </div>

          {/* Out of Credits Alert */}
          {generationsLeft <= 0 && (
            <div className="mt-4 sm:mt-8 p-2 sm:p-4 bg-rose-50 border border-rose-200 rounded-md sm:rounded-xl text-center">
              <p className="text-rose-600 font-bold text-[10px] sm:text-sm">You have reached the Monthly limit. Please Subscribe to Eascode Premium to unlock unlimited usage.</p>
            </div>
          )}

          <footer className="mt-6 sm:mt-14 text-center text-slate-400 text-[9px] sm:text-xs font-medium">
            © {new Date().getFullYear()} Eascode All Rights Reserved.
          </footer>
        </div>
      </div>

      {/* Review Modal */}
      {showReview && (
        <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex justify-center items-center z-50 animate-in fade-in duration-200 p-2 sm:p-4">
          <div className="bg-white p-4 sm:p-8 rounded-xl sm:rounded-3xl shadow-2xl w-full max-w-[95%] sm:max-w-sm text-center animate-in zoom-in-95 duration-200">
            <h3 className="text-lg sm:text-2xl font-bold text-slate-800 mb-3 sm:mb-6">Rate this Worksheet</h3>
            <div className="flex justify-center gap-1 sm:gap-2 mb-4 sm:mb-8">
              {[1, 2, 3, 4, 5].map(stars => (
                <button
                  key={stars}
                  onClick={() => {
                    setReview(stars);
                    setShowReview(false);
                    setReviewPromise(true);
                    setshowreward(true);
                    update_downloaded_ai_file(stars, internal_file_identifier);
                  }}
                  className="text-2xl sm:text-4xl hover:scale-125 transition-transform"
                >
                  ⭐
                </button>
              ))}
            </div>
            <button
              onClick={() => {
                setShowReview(false);
                setReviewPromise(true);
                setshowreward(true);
                update_downloaded_ai_file(0, internal_file_identifier);
              }}
              className="text-xs sm:text-sm text-slate-500 font-medium hover:text-slate-800 transition-colors underline"
            >
              Skip for now
            </button>
          </div>
        </div>
      )}

      {/* Reward Modal */}
      {showreward && (
        <div 
          className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex justify-center items-center z-[60] animate-in fade-in duration-200 p-2 sm:p-4"
          onClick={() => setshowreward(false)}
        >
          <div 
            className="bg-white p-4 sm:p-8 rounded-xl sm:rounded-3xl shadow-2xl w-full max-w-[95%] sm:max-w-sm text-center animate-in zoom-in-95 duration-200"
            onClick={(e) => e.stopPropagation()}
          >
            <img src="/thumbs_up.jpg" alt="Thumbs Up" className="w-24 sm:w-48 mx-auto mb-3 sm:mb-6 rounded-xl sm:rounded-2xl" />
            <button
              onClick={() => {
                setshowreward(false);
                handleNavigation('/RewardJourney');
              }}
              className="w-full bg-gradient-to-r from-indigo-600 to-violet-600 text-white font-bold py-2.5 sm:py-4 px-3 sm:px-6 rounded-lg sm:rounded-2xl shadow-lg hover:shadow-indigo-500/30 transition-all hover:scale-[1.02] text-[11px] sm:text-base"
            >
              🎁 Open Reward Center 🎁
            </button>
          </div>
        </div>
      )}
    </>
  );
}


export default Eascode_Agent_Lesson_CBSE_NCERT;
